<!-- src/components/Header.vue -->
<template>
    <div class="header">
      <div class="topTipTxt">
		    <i class="el-icon-warning-outline"></i>声明：本站非购彩平台，所有信息内容仅供娱乐参考，不代表平台任何立场。购彩请至线下彩票店，远离非法博彩。公益彩票，请理性购彩。
      </div>
      <div class="wrap1200">
        <div class="topBar">

          <div class="logo fl">
            <img src="../assets/iconLogo.png" >
          </div>
          <nav class="fl">
            <ul>
              <li v-for="item in navItems" :key="item.path">
                <router-link :to="item.path" :class="{ active: $route.path === item.path }">
                  {{ item.name }}
                </router-link>
              </li>
            </ul>
          </nav>

          <div class="fr">
            <div class="serviceI fl">
              <div class="expertIcon" @click="goMyExpert()">
              {{ expertText }}
              </div>
              <div class="kfIcon">
                <i class="el-icon-service"></i>
              </div>
              <div class="txt">
                <div class="phone">18832576178</div>
                <div class="wxMenuWrap">
                  <a class="wxMenu" href="https://work.weixin.qq.com/kfid/kfc5ef87544cdf69b43">
                    <i class="el-icon-s-comment"></i>微信咨询
                  </a>
                </div>
              </div>
            </div>
            <div class="righLink fl" v-if="!$store.state.isLoggedIn" style="display: block;">
              <el-button
                @click="$store.commit('OPEN_LOGIN_MODAL', 'login')"
                type="danger">登录</el-button>
              <el-button
                @click="$store.commit('OPEN_LOGIN_MODAL', 'register')"
                plain>注册</el-button>
            </div>
            <div class="righLink fl" @click="goMine" v-else>
              <el-avatar size="large" :src="'https://api.goucaiwang888.com'+$store.state.user.avatar"></el-avatar>
              <span>{{ $store.state.user.username }}</span>
            </div>

          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  export default {
    name: 'Header',
    data() {
      return {
        navItems: [
          { name: '首页', path: '/' },
          { name: '开奖公告', path: '/drawNotice' },
          { name: '走势图', path: '/trendChart' },
          { name: '资讯', path: '/service' },
          { name: '使用教程', path: '/using' },
          { name: 'App下载', path: '/appDown' },
          { name: '使用工具', path: '/tool' },
          { name: '关于我们', path: '/aboutUs' },
          // { name: '地图', path: '/map' },
        ]
      };
    },
    computed: {
        // 根据 store 中的 expert_id 动态显示文字
        expertText() {
          const expert_id = this.$store.state.user.expert_id?this.$store.state.user.expert_id:0;
          return expert_id > 0 ? '专家智选' : '申请专家';
        }
    },
    methods: {
      goMine(){
        this.$router.push({
            path: '/mine',
        });
      },
      goMyExpert(){
         // this.$router.push('/applyExpert');
        // console.log(this.$store.state.user);
        if(this.$store.state.isLoggedIn){
          if(this.$store.state.user.expert_id == 0)
          {
            if (this.$route.path !== '/applyExpert') {
              this.$router.push('/applyExpert');
            }
          }else{
            const target = { path: '/myExpertDetail', query: { expert_id: this.$store.state.user.expert_id } };
            if (!(this.$route.path === target.path && this.$route.query.expert_id == target.query.expert_id)) {
              this.$router.push(target);
            }
          }
        } else {
              this.$store.commit('OPEN_LOGIN_MODAL', 'login');
        }
      }
      // handleFeatureClick() {
      //   console.log(111)
      //   const token = localStorage.getItem('token');
      //   if (!token) {
      //     // 如果没有 token，显示登录弹窗
      //     console.log(222)
      //     console.log(this.$store)
      //     this.$store.commit('SET_SHOW_LOGIN_DIALOG', true);
      //   } else {
      //     // 如果有 token，执行特定功能
      //     console.log('执行特定功能');
      //   }
      // },
    }
  }
  </script>

  <style scoped>
  .header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1111;
    width: 100%;
    min-width: 1200px;
    background: #fff;
    box-shadow: 0px 0px 8px 4px rgba(0, 0, 0, 0.02);
  }
  .topTipTxt{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 35px;
    background: #ffe2e2;
    font-size: 12px;
    color: #EA4747;
  }
  .wrap1200 {
    width: 1200px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
  }
  .topBar {
    height: 70px;
    position: relative;
    z-index: 2;
  }
  .logo {
    width: 156px;
    /* height: 33px; */
    margin-top: 19px;
    margin-left: 10px;
  }
  .logo img{
    width: 100%;
    height: 100%;
  }
  .fl {
    float: left;
    display: inline;
  }
  .fr{
    float: right;
    display: inline;
  }
  nav{
    margin-left: 20px;
  }
  ul{
    list-style: none;
    margin: auto;
  }
  nav ul li{
    position: relative;
    cursor: pointer;
    float: left;
    height: 70px;
    line-height: 70px;
    padding: 0 12px;
    font-size: 14px;
    font-weight: 700;
    color: #333;
    /* 添加动画过渡 */
    transition: transform 0.2s ease, color 0.2s ease;
  }

  nav ul li:hover {
    transform: scale(1.1); /* 放大效果 */
    color: #EA4747;        /* 鼠标悬浮时字体颜色 */
  }

  nav ul li:hover a {
    color: #EA4747;        /* 悬浮时链接字体变色 */
  }
  a{
    text-decoration: none;
    color: #333;
  }
  .active {
    color: #EA4747;
    font-weight: bold;
  }
  .active:after {
    content: "";
    position: absolute;
    left: 50%;
    margin-left: -8px;
    bottom: 8px;
    width: 16px;
    height: 4px;
    border-radius: 2px;
    background: #EA4747;
    animation: .4s both activeScaleX;
    -webkit-animation: .4s both activeScaleX;
  }
 .serviceI {
   display: flex;
   align-items: center;  /* 垂直居中关键 */
   height: 70px;         /* 和导航条一样高 */
 }

.expertIcon {
  width: 100px;
  height: auto;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 16px;
  line-height: 1;
  font-weight: bold;

  /* 渐变文字颜色 */
  background: linear-gradient(90deg, #FFB347, #EA4747);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  /* 过渡动画 */
  transition: background 0.3s ease, transform 0.3s ease;
  /* font-style: normal; text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1); */
}


.expertIcon:hover {
  cursor: pointer;
  transform: scale(1.05);

  /* 改变文字渐变颜色 */
  background: linear-gradient(90deg, #EA4747, #FFB347);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

}


 .expertIcon img {
   max-height: 45px;   /* 限制高度，不超出导航条 */
   width: auto;
   display: block;
 }

 .kfIcon {
   font-size: 26px;    /* 缩小一下客服图标，和图片、文字协调 */
   color: #EA4747;
   margin-right: 7px;
 }
  .serviceI .txt {
    padding-left: 10px;
    padding-right: 10px;
    height: 44px;
    border-left: 1px solid #eee;
    margin-left: 9px;
  }
  .serviceI .phone {
    font-size: 14px;
    line-height: 1;
    font-weight: bold;
  }
  .serviceI .wxMenuWrap {
    position: relative;
    display: inline-block;
    vertical-align: top;
    margin-top: 6px;
  }
/*  .serviceI .wxMenu {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    width: 80px;
    height: 24px;
    border-radius: 4px;
    border: 1px solid #EEE;
    font-size: 12px;
    color: #666;
  }
  .serviceI .wxMenu i {
    display: block;
    font-size: 18px;
    margin: 0 3px 0 4px;
  } */
  .serviceI .wxMenu {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    width: 80px;
    height: 24px;
    border-radius: 4px;
    border: 1px solid #EEE;
    font-size: 12px;
    color: #666;
    transition: all 0.3s ease; /* 加个过渡动画更丝滑 */
  }

  .serviceI .wxMenu i {
    display: block;
    font-size: 18px;
    margin: 0 3px 0 4px;
    transition: color 0.3s ease; /* 图标颜色过渡 */
  }

  /* 鼠标滑过时变红 */
  .serviceI .wxMenu:hover {
    border-color: #EA4747;
    color: #EA4747;
  }

  .serviceI .wxMenu:hover i {
    color: #EA4747;
  }

  .righLink {
    margin-top: 15px;
    display: flex;
    align-items: center;
    cursor: pointer;   /* 鼠标悬停时变成小手 */
    transition: all 0.3s ease;
  }

  .righLink span {
    margin-left: 8px;
    transition: color 0.3s ease;
  }

  /* hover 效果：头像边框 + 昵称变红 */
  .righLink:hover span {
    color: #EA4747;
  }

  .righLink:hover .el-avatar {
    border: 2px solid #EA4747;
    box-sizing: border-box; /* 避免撑开布局 */
  }
  .el-button.is-plain:focus, .el-button.is-plain:hover {
    background: #FFF;
    border-color: #EA4747;
    color: #EA4747;
  }
  </style>



// WEBPACK FOOTER //
// src/components/Header.vue